<template>
  <b-card no-body>
    <b-card-body>
      <b-card-title>
        <h5>User Wise Pickup Statistics - Rack SubGroups</h5>
      </b-card-title>
      <div
        v-if="loading"
        class="text-center"
      >
        <b-spinner
          label="Small Spinner"
          variant="primary"
        />
      </div>
      <div v-else-if="!loading && chartData.length === 0">
        <p>No infromation available.</p>
      </div>
      <b-table
        v-else
        bordered
        :items="chartData"
        :fields="tableFields"
        striped
        class="compact-table"
        hover
        responsive="sm"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BTable, BSpinner, BCardTitle,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardBody, BTable, BSpinner, BCardTitle,
  },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableFields: [
        { key: 'pickup_initiated_by', label: 'Pickup User', sortable: true },
        { key: 'items_count', label: 'Items Picked', sortable: true },
        { key: 'pickup_time_per_item', label: 'Pickup Time per Item - Minutes', sortable: true },
      ],
    }
  },
}
</script>
